<script setup>
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  label: {
    type: String,
    default() {
      return '';
    },
  },
  placeholder: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  disabled: {
    type: Boolean,
    default() {
      return false;
    },
  },
  canDelete: {
    type: Boolean,
    default() {
      return false;
    },
  },
});

const emit = defineEmits(['update:modelValue', 'delete']);

//#region data

//#endregion

//#region computed

//#endregion

//#region methods
const handleClick = () => {
  emit('delete');
};
//#endregion


</script>

<template>
  <UiInput
    :disabled="disabled"
    :label="label"
    :model-value="modelValue"
    :placeholder="placeholder"
    class="ui-input-subid"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template
      v-if="canDelete"
      v-slot:nextIcon
    >
      <div class="ui-input-subid__icon">
        <UiIcon
          :size="14"
          color="#666"
          lib="fa"
          name="xmark"
          substyle="fas"
          @click="handleClick"
        />
      </div>
    </template>
  </UiInput>
</template>

<style lang="scss">
.ui-input-subid {
  &__icon {
    cursor: pointer;
    margin-right: 8px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>